<!--  -->
<template>
  <div class="agentList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select
        v-model.number="params.reviewStatus"
        size="small"
        placeholder="审核状态"
        clearable
        @change="getAdReviewList"
      >
        <el-option
          v-for="item in reviewStatusFunction"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-input
        placeholder="请输入商区码"
        size="small"
        clearable
        class="param-input"
        v-model="params.discCode"
        @change="getAdReviewList"
      ></el-input>
      <el-button type="primary" size="small" @click="getAdReviewList('status')">搜索</el-button>
      <!-- <el-button type="primary" icon="el-icon-arrow-right" size="small" @click="addAdReview(0)">发起申请</el-button>  -->
    </div>
    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
    >
      <el-table-column prop="cover" label="广告封面图" align="center" min-width="120">
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.cover"
            :width="'90px'"
            :height="scope.row.position===0?'195px':(scope.row.position===1?'81.3px':(scope.row.position===2?'178.4px':(scope.row.position===3?'62.5px':'32.5px')))"
          />
        </template>
      </el-table-column>
      <el-table-column prop="title" label="广告标题" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="href" label="广告地址" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.href }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="position" label="广告位置" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.position | positionFun }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="hrefType" label="广告链接类型" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.hrefType | hrefTypeFun  }}</span>
        </template>
      </el-table-column>-->
      <el-table-column prop="sortCode" label="排序号" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.sortCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="districtCode" label="商区码" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.districtCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" align="center" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="adID" label="广告ID" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.adID=scope.row.adID==='000000000000000000000000'?'未知':scope.row.adID}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="passAt" label="通过时间" align="center" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.passAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="refussAt" label="拒绝时间" align="center" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.refussAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="reviewer" label="审核人" align="center" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.reviewer }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="receiptInfo" label="审核信息" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.receiptInfo  }}</span>
        </template>
      </el-table-column>-->
      <!-- <el-table-column prop="optTypeAt" label="更新时间" align="center" min-width="220">
        <template slot-scope="scope">
          <span>{{ scope.row.optTypeAt  }}</span>
        </template>
      </el-table-column>-->
      <el-table-column
        prop="reviewStatus"
        label="审核状态"
        align="center"
        min-width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <p
            class="p1"
            :style="colors=(scope.row.reviewStatus===0)?'background:#FF9300':((scope.row.reviewStatus===1)?'background:green':'background:red')"
          >{{ scope.row.reviewStatus | reviewStatusFun}}</p>
          <p>{{ scope.row.receiptInfo }}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="toExamine(scope.row,'pass')"
            :disabled="scope.row.reviewStatus!==0?true:false"
          >通过</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="toExamine(scope.row,'refuse')"
            :disabled="scope.row.reviewStatus!==0?true:false"
          >拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[5, 10, 20, 30, 50, 100]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 添加审核检查 -->
    <check ref="check" @handlerAgentList="getAdReviewList" />
  </div>
</template>
<script>
// import addPage from './components/addPage';
import api from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import Check from "./components/check";
export default {
  data() {
    return {
      disabled: false,
      tableData: [],
      loading: false,
      total: 0,
      imgUrl: baseConfig.imgUrl,
      params: {
        pageNumber: 1,
        pageSize: 10,
        // status:'',
        discCode: "",
        id: "",
      },
      reviewStatusFunction: [
        { label: "审核中", value: 0 },
        { label: "通过", value: 1 },
        { label: "拒绝", value: 2 },
      ],
    };
  },
  components: { Check },
  created() {
    this.getAdReviewList();
  },
  methods: {
    getAdReviewList() {
      this.params.pageNumber = 1;
      this.loading = true;

      api.getAdReviewList(this.params).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.discCode = res.data.list.districtCode;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.loading = false;
      });
    },
    handlerAgentList() {
      this.getAdReviewList();
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getAdReviewList();
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getAdReviewList();
    },
    // 广告审核
    toExamine(data, type) {
      this.$refs.check.open(type, data);
    },
  },
};
</script>
<style scoped lang="scss">
.agentList-box {
  .p1 {
    color: #fff;
  }
  .v-number {
    vertical-align: middle;
  }
  .el-input {
    margin-left: 0 !important;
  }
  .view-details {
    margin-left: 10px;
    color: #e63765;
    font-size: 18px;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      color: #eb5f84;
    }
  }
  /deep/.col_layout {
    /deep/ div {
      display: flex;
      justify-content: center;
      padding-left: 50px;
      button {
        margin-left: auto;
      }
    }
  }
}
</style>
